import React, { useState, useEffect } from 'react';
import './Login.css';

const Login = ({ onLogin }) => {
  const [showLoginForm, setShowLoginForm] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      setError('Por favor, completa todos los campos');
      return;
    }
    setIsLoading(true);
    setError('');
    try {
      await new Promise((resolve) => setTimeout(resolve, 500));
      const result = await onLogin(username, password);
      if (!result.success) {
        setError(result.message || 'Credenciales incorrectas');
        setIsLoading(false);
      }
      // Si el login es exitoso, el estado de loading se gestiona en App.js
    } catch (err) {
      setError('Error de autenticación.');
      setIsLoading(false);
    }
  };

  // Removed guest access function to avoid unused variables — only credential logins allowed

  const handleShowLoginForm = () => {
    setShowLoginForm(true);
  };

  const [bgUrl, setBgUrl] = useState('/images/imagen_login.jpg');

  useEffect(() => {
    const updateBg = () => {
      if (window.innerWidth >= 1025) {
        setBgUrl('/images/fondo_login_pc.png');
      } else {
        setBgUrl('/images/imagen_login.jpg');
      }
    };

    updateBg();
    window.addEventListener('resize', updateBg);
    return () => window.removeEventListener('resize', updateBg);
  }, []);

  const handleBackToSelection = () => {
    setShowLoginForm(false);
    setError('');
    setUsername('');
    setPassword('');
  };

  const toggleShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <div className="login-screen">
      <div
        className="login-background"
        style={{
          backgroundImage: `linear-gradient(135deg, rgba(44, 62, 80, 0.7) 0%, rgba(52, 73, 94, 0.5) 50%, rgba(44, 62, 80, 0.7) 100%), url(${bgUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
        }}
      ></div>
      <div className="login-container">
        <div className="login-box glass">
          <div className="login-header">
            <img
              src="/images/logo boda.png"
              alt="Logo Dani y Ana"
              className="login-logo"
            />
            <h1 className="login-title">Dani & Ana</h1>
            <p className="login-subtitle">8 de Agosto, 2026</p>
            <div className="login-divider"></div>
          </div>

          {!showLoginForm ? (
            // Pantalla inicial con botón de acceso
            <div className="login-welcome">
              <div className="welcome-message">
                <h2 className="welcome-title">¡Bienvenido!</h2>
                <p className="welcome-text">
                  Estamos encantados de compartir este momento tan especial contigo
                </p>
              </div>

              <div className="login-actions">
                <button
                  onClick={handleShowLoginForm}
                  className="main-login-button"
                >
                  <i className="fas fa-key"></i>
                  <span>Acceder con credenciales</span>
                </button>
              </div>

              {error && (
                <div className="error-message">
                  <i className="fas fa-exclamation-triangle"></i>
                  {error}
                </div>
              )}
            </div>
          ) : (
            // Formulario de login
            <>
              <div className="login-form-header">
                <button
                  onClick={handleBackToSelection}
                  className="back-button"
                  type="button"
                >
                  <i className="fas fa-arrow-left"></i>
                  Volver
                </button>
              </div>

              <form onSubmit={handleSubmit} className="login-form">
                <div className="input-group">
                  <i className="fas fa-user input-icon"></i>
                  <input
                    type="text"
                    placeholder="Usuario"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    disabled={isLoading}
                    className="login-input"
                    autoComplete="username"
                  />
                </div>

                <div className="input-group">
                  <i className="fas fa-lock input-icon"></i>
                  <input
                    type={showPassword ? 'text' : 'password'}
                    placeholder="Contraseña"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    disabled={isLoading}
                    className="login-input"
                    autoComplete="current-password"
                    aria-label="Contraseña"
                  />

                  <button
                    type="button"
                    className="password-toggle"
                    onClick={toggleShowPassword}
                    aria-pressed={showPassword}
                    aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                    disabled={isLoading}
                  >
                    <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`} />
                  </button>
                </div>

                {error && (
                  <div className="error-message">
                    <i className="fas fa-exclamation-triangle"></i>
                    {error}
                  </div>
                )}

                <button
                  type="submit"
                  disabled={isLoading}
                  className={`login-button ${isLoading ? 'loading' : ''}`}
                >
                  {isLoading ? (
                    <>
                      <i className="fas fa-spinner fa-spin"></i>
                      Verificando...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-heart"></i>
                      Entrar
                    </>
                  )}
                </button>
              </form>
            </>
          )}

          <div className="login-footer">
            <p className="login-hint">
              {!showLoginForm 
                ? "💝 Te esperamos para celebrar juntos" 
                : "💝 Usa tus credenciales de invitación"
              }
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
